import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { UniqueServiceNameInput } from './function';

export const UniqueServiceNameInputFormField = FormFieldBlueprint.make({
  name: 'unique-service-name-input',
  params: {
    field: async () =>
      createFormField({
        name: 'UniqueServiceNameInput',
        component: UniqueServiceNameInput,
      }),
  },
});
